import { graphql } from 'react-relay';

export const breadcrumbFragment = graphql`
    fragment Breadcrumb_data on Breadcrumb @relay(plural:true) {
        label
        link
    }
`;
